import { action, observable } from 'mobx';
import { app } from '../App';

export interface IOrderPadInfo {
  url: string;
}

export class OrderPad {
  @observable public isOrderPadInfoLoading: boolean = false;
  @observable public orderPadUrl: string | null = null;

  @action
  public fetchOrderPadInfo = async (): Promise<boolean> => {
    try {
      if (this.orderPadUrl !== null) {
        return true;
      }

      this.isOrderPadInfoLoading = true;

      const service = app.service('order-pad');
      const orderPadInfo: IOrderPadInfo = await service.find();

      this.orderPadUrl = orderPadInfo.url;
      this.isOrderPadInfoLoading = false;

      return true;
    } catch (error) {
      setTimeout(() => {
        this.fetchOrderPadInfo();
      }, 1000);

      throw error;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/OrderPad.ts